import { useState } from "react";
import { api } from "../../lib/api";

const interests = ["Coding", "Cybersecurity", "Business", "Finance", "Building", "Construction", "Agriculture", "Food", "Media", "Journalism", "AI", "Networking"];

export default function ProgrammeFinder() {
  const [selected, setSelected] = useState([]);
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");

  function toggle(value) {
    setSelected((current) => current.includes(value) ? current.filter((item) => item !== value) : [...current, value]);
  }

  async function submit() {
    setError("");
    try {
      const data = await api("/api/programme-finder", { method: "POST", body: JSON.stringify({ interests: selected }) });
      setResults(data.recommendations || []);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <main className="bg-white px-4 py-16">
      <section className="mx-auto max-w-5xl">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-emerald-700">Smart Admission Tool</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Programme Finder</h1>
        <p className="mt-3 max-w-2xl text-slate-600">Choose your interests and get recommended programmes that match your career direction.</p>

        <div className="mt-8 flex flex-wrap gap-3">
          {interests.map((interest) => (
            <button key={interest} onClick={() => toggle(interest)} className={`rounded-full px-5 py-3 text-sm font-bold ${selected.includes(interest) ? "bg-emerald-700 text-white" : "bg-slate-100 text-slate-700"}`}>
              {interest}
            </button>
          ))}
        </div>

        <button onClick={submit} className="mt-8 rounded-xl bg-slate-950 px-6 py-3 font-bold text-white">Find Programmes</button>
        {error && <div className="mt-6 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {results.map((result) => (
            <div key={result.programme} className="rounded-3xl border border-slate-200 p-6">
              <h2 className="text-xl font-bold text-slate-900">{result.programme}</h2>
              <p className="mt-2 text-sm text-slate-500">Match score: {result.score}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
